
$(document).ready(function () {
    if(document.querySelector('#item-nota[data-template="historia"]') != null)
    {
        //navegacion storytelling
        $(window).scroll(function() {
            var limite = $('.encabezado').height();

            var navTop = $('#nota nav div').offset().top;
            if (navTop > limite) {
                $('#nota nav div').addClass('active');
            } else {
                $('#nota nav div').removeClass('active');
            }

            $('.link-story').each(function() {
                var linkBottom = $(this).offset().top + $(this).height();
                if (linkBottom > limite) {
                    $(this).addClass('positivo');
                } else {
                    $(this).removeClass('positivo');
                }
            });
        });

        //START: SCROLL storytelling-nav
        $(document).on("scroll", onScroll);

        var margen = $('#cabezal').outerHeight() + 20;

        $('#nota nav div a[href^="#"]').on('click',
            function(e) {
                e.preventDefault();
                $(document).off("scroll");

                $('#nota nav div a').each(function() {
                    $(this).removeClass('active');
                })
                $(this).addClass('active');

                var target = this.hash;
                var $target = $(target);

                $('html, body').stop().animate({
                        'scrollTop': $target.offset().top - margen
                    },
                    500,
                    'swing',
                    function() {
                        //window.location.hash = target - margen;
                        $(document).on("scroll", onScroll);
                    });
            });
        //END: SCROLL storytelling-nav   

        var notaCuerpo = $('#cuerpo');
        var midVentana = window.innerHeight / 2;
        var midNav = $('#nota nav div').height() / 2;
        var notaNav = $('.storytelling #nota nav');
        var finNota = notaCuerpo.position().top + notaCuerpo.height(); //no cambia
        var topNav = notaNav.position().top;
        var altoNav = notaNav.outerHeight(); //no cambia
        var tope = finNota - altoNav - topNav;
        notaNav.css({ top: (window.innerHeight / 2) - (notaNav.outerHeight() / 2) });


        function onScroll(event) {
            var scrollPos = $(document).scrollTop();

            //Sticky nav
            if (tope <= scrollPos) {
                notaNav.addClass("abs");
                notaNav.css({ top: finNota - midNav });
            } else {
                notaNav.removeClass("abs");
                notaNav.css({ top: (window.innerHeight / 2) - (notaNav.outerHeight() / 2) });

            }

            //cambio de header
            if ($('#nota .encabezado').outerHeight() / 3 <= scrollPos) {
                $('#cabezal').removeClass("transparente");
            } else {
                $('#cabezal').addClass("transparente");
            }

            //ancla de la navegaci�n
            $('#nota nav div a').each(function() {
                var currLink = $(this);
                var refElement = $(currLink.attr("href"));
                if (refElement.position().top - midVentana <= scrollPos &&
                    notaCuerpo.position().top + notaCuerpo.height() - midVentana > scrollPos) {
                    $('#nota nav div a').removeClass("active");
                    currLink.addClass("active");
                } else {
                    currLink.removeClass("active");
                }
            });
        }
    }
});


// WEBPACK FOOTER //
// ./Statics/scripts/common/storytelling.js